import { render, staticRenderFns } from "./Fractal.vue?vue&type=template&id=77f5b524&scoped=true&lang=pug&"
import script from "./Fractal.ts?vue&type=script&lang=ts&"
export * from "./Fractal.ts?vue&type=script&lang=ts&"
import style0 from "./Fractal.vue?vue&type=style&index=0&id=77f5b524&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f5b524",
  null
  
)

export default component.exports